import { Component, OnInit, Input, Inject, ViewChild, OnDestroy } from '@angular/core';
import { FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { switchMap, takeUntil } from 'rxjs/operators';
import { AsamcoUserService } from '@asamco/base';
import { FormHelpers, showErrorSwal } from '@asamco/utils';
import { L10N_LOCALE, L10nLocale, L10nTranslatePipe } from 'angular-l10n';
import { BehaviorSubject, of, Subject } from 'rxjs';
import { catchError } from 'rxjs/operators';
import Swal from 'sweetalert2';
import { Link } from '../../interfaces/link.interface';
import { AlCompanyService } from '../../services/al-company.service';
import { LinkService } from '../../services/link.service';
import { AsValidatorDirective } from '../../../../../../base/src/lib/as-validator/as-validator.directive';
import { DxTextBoxModule, DxDateBoxModule } from 'devextreme-angular';
import { NgIf, AsyncPipe } from '@angular/common';
import { DeleteLinkModalComponent } from '../delete-link-modal/delete-link-modal.component';

@Component({
    selector: 'al-link-edit-general',
    templateUrl: './link-edit-general.component.html',
    styleUrls: ['./link-edit-general.component.scss'],
    standalone: true,
    imports: [
        NgIf,
        FormsModule,
        ReactiveFormsModule,
        DxTextBoxModule,
        AsValidatorDirective,
        DxDateBoxModule,
        AsyncPipe,
        L10nTranslatePipe,
		DeleteLinkModalComponent
    ],
})
export class LinkEditGeneralComponent implements OnInit, OnDestroy {
	/** The input link */
	@Input()
	link: Link;

	/** Form group for general form */
	@Input()
	formGroup: FormGroup;

	@ViewChild(DeleteLinkModalComponent)
	deleteLinkModal: DeleteLinkModalComponent;

	destroy$ = new Subject<void>();

	public formInitialized$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
	public admin: boolean;
	public dateFormat: string = '';

	constructor(
		@Inject(L10N_LOCALE) public locale: L10nLocale,
		private asamcoUserService: AsamcoUserService,
		private companyService: AlCompanyService,
		private linkService: LinkService,
		private router: Router
	) {}

	ngOnInit(): void {
		this.companyService
			.getCompanyDateFormat()
			.pipe(
				switchMap(dateFormat => {
					this.dateFormat = dateFormat;
					return this.linkService.get(this.link.id);
				}),
				switchMap(retrievedLink => {
					this.initializeForm(retrievedLink);
					return this.asamcoUserService.isAdmin();
				})
			)
			.subscribe((isAdmin: boolean) => {
				this.admin = isAdmin;
				if (this.admin) {
					this.formGroup.get('expiryDate').enable({ emitEvent: true });
				}
			});
	}

	private initializeForm(retrievedLink: any) {
		this.formGroup.addControl('name', new FormControl(retrievedLink.name, Validators.required));
		this.formGroup.addControl('expiryDate', new FormControl({ value: retrievedLink.expiryDate, disabled: true }, Validators.required));
		this.formInitialized$.next(true);
	}

	deleteLink(): void {
		this.deleteLinkModal.showAndAwait().pipe(takeUntil(this.destroy$)).subscribe(() => {
			this.deleteLinkById(this.link.id);
		});
	}

	public deleteLinkById(linkId: number): void {
		this.linkService
			.deleteLink(linkId)
			.pipe(
				catchError(err => {
					showErrorSwal(err);
					return of(false);
				})
			)
			.subscribe(
				e => {
					if (e) {
						this.router.navigate(['/']);
						Swal.fire({
							icon: 'success',
							title: 'Succesfully deleted the link',
						});
					}
				},
				error => {
					showErrorSwal(error);
				}
			);
	}

	public save() {
		const result = {};

		if (FormHelpers.validateForm(this.formGroup, result)) {
			return result;
		}

		return null;
	}

	ngOnDestroy(): void {
		this.destroy$.next();
	}
}
